import { handleError } from "@common/components/helpers/error";
import IncidentClient from "@common/api/IncidentClient";
import EnforcementAction from "@common/redux/actions/EnforcementAction";
import { enforcementTypesToSelect } from "../options/enforcementTypeOptions";

const fetchEnforcementTypes = () => {
  EnforcementAction.setLoadingTypes(true).then(() => {
    IncidentClient.MetaData()
      .then((response) => {
        const options = enforcementTypesToSelect(
          response.enforcementVisitTypes,
        );
        EnforcementAction.dispatch({
          typeOptions: options,
        });
      })
      .catch((error) => {
        console.error(error);
        handleError(error);
      })
      .finally(() => EnforcementAction.setLoadingTypes(false));
  });
};

export default fetchEnforcementTypes;
